import React from "react";
import { Display, PL } from "@components/ui/typography";
import Section from "@layouts/section";
import ScheduleButton from "@components/ui/schedule-button";
import LottieAnimation from "@/components/lottie";
import AnimationCTAsectionDeskTop from "@animations/cta-section/v1/homepage-cta-desktop.json";
import AnimationCTAsectionMobile from "@animations/cta-section/v1/homepage-cta-mobile.json";
import CtaSupportText from "@/components/cta-support-text";

interface HomepageCtaProps {
  title: string;
  description: string;
  cta: string;
  ctaHintText?: string;
  className?: string;
}

const HomepageCta: React.FC<HomepageCtaProps> = ({
  title,
  description,
  cta,
  ctaHintText,
  className
}) => {
  return (
    <Section className="mt-24 md:mt-40 overflow-hidden relative">
      <div className="bg-primary text-emerald-50 py-24 md:py-32 px-6 rounded-2xl md:rounded-4xl text-center md:flex justify-center z-[5] relative">
        <div className="hidden md:block absolute w-52 left-20 top-0 z-[-1]">
          <LottieAnimation animationData={AnimationCTAsectionDeskTop} />
        </div>
        <div>
          <Display className="max-w-5xl mx-auto">{title}</Display>
          <PL className="mt-12 max-w-2xl mx-auto">{description}</PL>
          <ScheduleButton variant="dark" className="inline-block mt-16" size="lg">
            {cta}
          </ScheduleButton>
          <CtaSupportText>{ctaHintText}</CtaSupportText>
        </div>
        <div className="md:hidden">
          <LottieAnimation
            animationData={AnimationCTAsectionMobile}
            className={`${className} -mx-6`}
          />
        </div>
      </div>
    </Section>
  );
};

export default HomepageCta;
